import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-api-key',
  templateUrl: './api-key.component.html',
  styleUrls: ['./api-key.component.scss']
})
export class ApiKeyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
